import React from 'react';

interface Props {
  onClick?: () => void;
  style?: React.CSSProperties;
  color?: string;
  opacity?: number;
}
function CloseButtonSVG(props: Props) {
  const {onClick, style, color = 'white', opacity = 0.5} = props;
  return (
    <button
      onClick={onClick}
      aria-label="Close"
      style={{
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        padding: 0,
        ...style,
      }}
    >
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity={opacity}>
          <path
            d="M20.4483 5.441L19.4771 4.5L12.6883 11.1067L5.86855 4.5L4.89844 5.441L11.7182 12.0477L4.91472 18.6215L5.88484 19.5625L12.6883 12.9887L19.4787 19.5826L20.4499 18.6416L13.6584 12.0477L20.4483 5.441Z"
            fill={color}
          />
        </g>
      </svg>
    </button>
  );
}

export default CloseButtonSVG;
